import { FC } from "react"
import * as React from "react"

import { explanationVideos } from "config/explanation-videos"
import { IFaqCategoryVideo } from "config/faq"
import * as styles from "./styles.module.scss"
import SummaryVideo from "../SummaryVideo"

export interface SummaryVideosProps {
  videos: IFaqCategoryVideo[]
}

const SummaryVideos: FC<SummaryVideosProps> = ({ videos }) => {
  return (
    <ul className={styles.summaryVideos}>
      {videos.map((video) => (
        <li className={styles.item} key={video.id}>
          <SummaryVideo
            title={video.title}
            poster={explanationVideos[video.id].poster}
            embedUrl={explanationVideos[video.id].embedUrl}
          />
        </li>
      ))}
    </ul>
  )
}

export default SummaryVideos
